/**
 * 노트 사진 업로드 제한. 서버 검증과 브라우저 사전 검증이 같은 값을 쓴다.
 *
 * 4MB인 이유: Vercel 함수는 요청 본문이 4.5MB를 넘으면 우리 코드에 닿기 전에 413을
 * 돌려준다. multipart 경계 등 오버헤드가 있어 파일 크기는 여유를 둔 4MB로 잡았다.
 * (Supabase 버킷 한도 5MB는 이 값보다 크므로 그대로 둬도 된다.)
 */
export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024;
export const MAX_UPLOAD_LABEL = "4MB";

/**
 * 무료 플랜의 월 업로드 상한. 노트 자체는 계속 쌓이고, "이번 달에 새로 만든 개수"만
 * 센다(한국 시간 기준, lib/week.ts getMonthStart). 유료 플랜이 생기면 플랜별로
 * 다른 값을 쓰도록 확장한다. (INFRA.md B2, 2026-09-22 결정: 무료 플랜 월 3건)
 */
export const MAX_NOTES_PER_MONTH = 3;

const ALLOWED_MIME = new Set(["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"]);
const ALLOWED_EXT = new Set(["jpg", "jpeg", "png", "webp", "heic", "heif"]);

export type UploadCheck = { ok: true } | { ok: false; status: 413 | 415; message: string };

// 일부 브라우저는 HEIC의 type을 빈 문자열로 주므로, 그때만 확장자로 판단한다.
export function checkUploadFile(file: { name: string; size: number; type: string }): UploadCheck {
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  const typeOk = file.type ? ALLOWED_MIME.has(file.type) : ALLOWED_EXT.has(ext);
  if (!typeOk) {
    return { ok: false, status: 415, message: "JPG, PNG, WEBP, HEIC 사진만 올릴 수 있어요." };
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return {
      ok: false,
      status: 413,
      message: `사진이 너무 커요. ${MAX_UPLOAD_LABEL} 이하의 사진으로 올려주세요. (현재 ${(file.size / 1024 / 1024).toFixed(1)}MB)`,
    };
  }
  return { ok: true };
}
